import axios from "axios";
import * as actions from "./actionsTypes";
import messages from "../../messages";
import toastr from "toastr";
import { ResponsiveEmbed } from "react-bootstrap";
import StrategicPillarServices from "./StrategicPillar.services"

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: true,
  positionClass: "toast-top-right",
  preventDuplicates: false,
  onclick: null,
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "5000",
  extendedTimeOut: "1000",
  showEasing: "swing",
  hideEasing: "linear",
  showMethod: "fadeIn",
  hideMethod: "fadeOut",
};

export const resetStrategicPillar = () => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_STRATEGIC_PILLAR,
      payload: true,
    });
    dispatch({
      type: actions.GET_STRATEGIC_PILLAR,
      payload: {
        strategicPillars: [],
        strategicPillarsLength: 0,
      },
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.STRATEGIC_PILLAR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_STRATEGIC_PILLAR,
      payload: false,
    });
  }
};

export const getStrategicPillar = (filters) => async (dispatch) => {
  try {

    dispatch({
      type: actions.LOADING_STRATEGIC_PILLAR,
      payload: true,
    });
    const resp = await StrategicPillarServices.getStrategicPillar(filters);
    dispatch({
      type: actions.GET_STRATEGIC_PILLAR,
      payload: {
        strategicPillars: resp.data.data || [],
        strategicPillarsLength: resp.data.count || 0,
      },
    });
    dispatch({
      type: actions.STRATEGIC_PILLAR_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = ex.response.data.mensaje;
            break;
          case 404:
            if (ex.response.data && ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.notFound;
            }
            break;
          default:
            message = messages.errorMessage;
            break;
        }
      } else {
        message = messages.networkError;
      }
    } else {
      message = messages.applicationError
    }
    dispatch({
      type: actions.STRATEGIC_PILLAR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_STRATEGIC_PILLAR,
      payload: false,
    });
  }
};

export const getStrategicPillarById = (id) => async (dispatch) => {
  try {
    dispatch({
      type: actions.LOADING_STRATEGIC_PILLAR_BY_ID,
      payload: true,
    });
    const resp = await StrategicPillarServices.getStrategicPillarById(id);
    dispatch({
      type: actions.GET_STRATEGIC_PILLAR_BY_ID,
      payload: resp.data,
    });
    dispatch({
      type: actions.STRATEGIC_PILLAR_FAIL,
      payload: "",
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.STRATEGIC_PILLAR_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.LOADING_STRATEGIC_PILLAR_BY_ID,
      payload: false,
    });
  }
};

export const saveStrategicPillar = (data, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_STRATEGIC_PILLAR,
      payload: true,
    });
    const resp = await StrategicPillarServices.saveStrategicPillar(data);
    const { strategicPillars, strategicPillarsLength } = getState().strategicPillar;
    const _strategicPillars = [...strategicPillars, resp.data.pilar_principal];
    dispatch({
      type: actions.GET_STRATEGIC_PILLAR,
      payload: {
        strategicPillars: _strategicPillars,
        strategicPillarsLength: strategicPillarsLength + 1,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data.mensaje) {
              message = ex.response.data.mensaje;
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_STRATEGIC_PILLAR,
      payload: false,
    });
  }
};

export const editStrategicPillar = (data, id, index, setShowModal) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.SAVE_LOADING_STRATEGIC_PILLAR,
      payload: true,
    });
    const resp = await StrategicPillarServices.editStrategicPillar(id, data);
    const { strategicPillars, strategicPillarsLength } = getState().strategicPillar;
    strategicPillars[index] = resp.data.pilar_principal;
    dispatch({
      type: actions.GET_STRATEGIC_PILLAR,
      payload: {
        strategicPillars: strategicPillars,
        strategicPillarsLength: strategicPillarsLength,
      },
    });
    dispatch({
      type: actions.FORM_FAIL,
      payload: "",
    });
    setShowModal(false)
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    dispatch({
      type: actions.FORM_FAIL,
      payload: message,
    });
  } finally {
    dispatch({
      type: actions.SAVE_LOADING_STRATEGIC_PILLAR,
      payload: false,
    });
  }
};

export const deleteStrategicPillar = (id, index) => async (dispatch, getState) => {
  try {
    dispatch({
      type: actions.LOADING_STRATEGIC_PILLAR,
      payload: true,
    });
    await StrategicPillarServices.deleteStrategicPillar(id);
    const { strategicPillars, strategicPillarsLength } = getState().strategicPillar;
    strategicPillars.splice(index, 1);
    dispatch({
      type: actions.GET_STRATEGIC_PILLAR,
      payload: {
        strategicPillars: strategicPillars,
        strategicPillarsLength: strategicPillarsLength - 1,
      },
    });
    dispatch({
      type: actions.STRATEGIC_PILLAR_FAIL,
      payload: "",
    });
    toastr.success(messages.successMessage, "", {
      progressBar: true,
      rtl: true,
    });
  } catch (ex) {
    let message = null;
    if (axios.isAxiosError(ex)) {
      if (ex.response?.status) {
        switch (ex.response.status) {
          case 400:
            if (ex.response.data && ex.response.data[0]) {
              message = ex.response.data[0];
            } else {
              message = messages.errorMessage + " " + ex.response.statusText;
            }
            break;
          case 404:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          case 500:
            message = messages.errorMessage + " " + ex.response.statusText;
            break;
          default:
            message = ex.response.data;
            break;
        }
      } else {
        message =
          ex.message === "Network Error" ? messages.networkError : ex.message;
      }
    } else {
      message =
        ex.message === "Network Error" ? messages.networkError : ex.message;
    }
    toastr.error(message, "", {
      progressBar: true,
      rtl: true,
    });
  } finally {
    dispatch({
      type: actions.LOADING_STRATEGIC_PILLAR,
      payload: false,
    });
  }
};
